<template>
  <q-toolbar class="toolbar">
    <q-toolbar-title>
      <a :href="'https://openmeasures.io'" target="_blank" class="parent">
        <img :src='omLogo' class='om-logo' />
      </a>
    </q-toolbar-title>
    <q-space />

    <q-btn
      v-if="isHome"
      class='edit-query'
      label='Edit Query'
      unelevated
      dense
      color="purple"
      @click="$emit('toggleToolBar')"
      style='font-size: 10px; line-height: 13px; padding: 3px 10px;'
    />

    <div class="right-part">
      <div
        class="right-part-nav">
        <a href='https://blog.openmeasures.io/' target='_blank'>
          <ButtonInner>
            <span class='top-bar-link'>{{ $t("nav.blog") }}</span>
          </ButtonInner>
        </a>

        <a href='https://docs.openmeasures.io/docs' target='_blank'>
          <ButtonInner>
            <span class='top-bar-link'>{{ $t("nav.docs") }}</span>
          </ButtonInner>
        </a>
        <a href='https://form.typeform.com/to/EexZftxx' target='_blank'>
          <ButtonInner class="purple">
            <span class='top-bar-link'>{{ $t("nav.contact") }}</span>
          </ButtonInner>
        </a>
      </div>
      <div class="right-part-lang">
        <LanguagePickerDropdown />
      </div>
    </div>
  </q-toolbar>
</template>

<script>
import ButtonInner from '@/components/input/ButtonInner'
import LanguagePickerDropdown from '@/components/input/LanguagePickerDropdown'
import omLogo from '@/assets/open-measures-logo-full.svg'
import homeLogo from '@/assets/om-logo.svg'
const { TIMELINE, LINKS, ACTIVITY, SEARCH } = require('@/constants/tools')
const { ENV, PRODUCTION } = require('@/constants/misc')

export default {
  data () {
    return {
      omLogo,
      homeLogo,
      env: ENV,
      large: true,
      showENV: ENV !== PRODUCTION
    }
  },
  computed: {
    isHome () {
      return [TIMELINE, LINKS, ACTIVITY, SEARCH].includes(this.$route.name)
    },
  },
  methods: {
    updateLarge () {
      this.large = window.matchMedia('(min-width: 1000px)').matches
    },
  },
  components: {
    ButtonInner,
    LanguagePickerDropdown
  }
}
</script>

<style scoped lang="scss">
.purple {
  color: var(--color-white);
  background-color: var(--color-purple);
  margin: 5px;
}

.parent {
  display: flex;
  align-items: center;
}

.toolbar {
  background: var(--color-off-white);
  border-bottom: var(--border-width) solid var(--color-light-grey);

  .router-link-active {
    text-decoration: none !important;
  }

  .toolbar-back {
    font-size: 24px;
    font-weight: bold;
  }

  .om-logo {
    height: 22px;
  };

  .home-mobile-menu {
    display: none;
  }

  .edit-query {
    display: none;
    margin-right: 2em;
    padding: 0 5px;
  }

  .right-part {
    display: flex;
    align-items: center;

    .right-part-nav {
      display: flex;
      align-items: center;

      > * {
        margin-right: 3rem;
      }
    }
    a {
      font-weight: bold;
      color: var(--color-white);

      &.router-link-exact-active {
        color: gray;
      }
    }

    .api-button { cursor: pointer; }
  }

  .top-bar-link {
    font-size: 12px;
  }
}

@media (max-width: 1000px) {
  .toolbar .edit-query {
    display: grid;
  }
}

@media (max-width: 860px) {
  .toolbar .top-bar-link {
    font-size: 14px;
  }
}

@media (max-width: 650px) {
  .toolbar {
    .edit-query {
      margin-right: 5px;
    }

    .home-mobile-menu {
      display: grid;
    }

    .right-part {
      margin-right: 1rem;
      display: none;
    }
  }
}
</style>
